module.exports = __webpack_public_path__ + "img/tab13.6fd3520b.jpg";